
export const api_url = `${process.env.NEXT_PUBLIC_API_URL}`




export const baseUrl ={
    users:`${api_url}/users`,
    admin:`${api_url}/admin`,
    wallet:`${api_url}/wallets`,
    reviews:`${api_url}/reviews`,
    booking:`${api_url}/bookings`,
    payment:`${api_url}/payments`,
    chatBaseUrl:`${api_url}/chat`,
    listings:`${api_url}/listings`,
    transactions:`${api_url}/transactions`,
    locationProfile:`${api_url}/location-profile`,
    notification:`${api_url}/notification`

}